<form [formGroup]="mainForm" *ngIf="loaded">
    <h1 mat-dialog-title>{{ 'EMPLOYEE_REVIEW_DIALOG.TITLE' | translate }}</h1>
    <div mat-dialog-content>

        <app-search [title]="'EMPLOYEE_REVIEW_DIALOG.BY_EMPLOYEE_LABEL' | translate" formControlName="byEmployee" [showAddButton]="false" [inlineButtons]="false" [isAllowSearch]="true" [config]="searchEmployeeConfig"
            (change)="onByEmployeeChange($event)"
        ></app-search>

        <app-search *ngIf="reviewType === reviewTypes.TER" formControlName="aboutEmployee"
            [title]="'EMPLOYEE_REVIEW_DIALOG.ABOUT_EMPLOYEE_LABEL' | translate" [showAddButton]="false" [inlineButtons]="false" [isAllowSearch]="true" [config]="searchEmployeeConfig"
            (change)="onAboutEmployeeChange($event)"
        ></app-search>

        <div class="about-employee-options">
            <mat-checkbox *ngIf="isPersonalQuestionSetEnabled && isPositionBasedAssessmentEnabled" class="multiline" formControlName="isAuraLeader">{{ 'EMPLOYEE_REVIEW_DIALOG.AURA_LEADER_TEXT' | translate }}</mat-checkbox>
        </div>

        <mat-form-field appearance="outline" *ngIf="reviewType === reviewTypes.TER" class="width-max">
            <mat-label>{{ 'EMPLOYEE_REVIEW_DIALOG.ASSESSMENT_DIRECTION_LABEL' | translate }}</mat-label>
            <mat-select formControlName="assessmentType" disableOptionCentering class="drop-fix">
                <mat-option *ngFor="let item of assessmentTypeList" [value]="item.id">{{ item.translateKey | translate }}</mat-option>
            </mat-select>
            <mat-error msg></mat-error>
        </mat-form-field>

        <mat-form-field appearance="outline" class="width-max">
            <mat-label>{{ 'EMPLOYEE_REVIEW_DIALOG.DEADLINE_LABEL' | translate }}</mat-label>
            <input matInput [matDatepicker]="pickerStartEdit" formControlName="deadline">
            <mat-datepicker-toggle matSuffix [for]="pickerStartEdit"></mat-datepicker-toggle>
            <mat-datepicker #pickerStartEdit></mat-datepicker>
        </mat-form-field>

        <div formArrayName="questionSets" class="settings-panel" *ngIf="isPersonalQuestionSetEnabled">
            <div class="panel-title">{{ 'EMPLOYEE_REVIEW_DIALOG.CUSTOM_QUESTIONNAIRES' | translate }}</div>
            <div class="panel-content simple-border">
                <ng-container *ngFor="let child of questionSets.controls; let i = index">
                    <ng-container [formGroupName]="i">
                        <mat-checkbox class="multiline" formControlName="isSelected">{{ questionSetList[i].name }}</mat-checkbox>
                    </ng-container>

                </ng-container>
               
            </div>
        </div>        
  
    </div>
    <div mat-dialog-actions class="flex-h flex-end">
      <button mat-flat-button color="primary" (click)="ok()" type="submit">{{ 'GENERAL.OK' | translate }}</button>
      <button mat-flat-button color="accent" [mat-dialog-close]>{{ 'GENERAL.CANCEL' | translate }}</button>
    </div>
  </form>
